var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-form-item", {
        attrs: { label: _vm.i18nt("designer.setting.tabPaneSetting") },
      }),
      _vm._v(" "),
      _c(
        "el-form-item",
        { staticClass: "panes-setting", attrs: { "label-width": "0" } },
        [
          _c(
            "draggable",
            _vm._b(
              { attrs: { tag: "ul", list: _vm.selectedWidget.tabs } },
              "draggable",
              {
                group: "panesGroup",
                ghostClass: "ghost",
                handle: ".drag-option",
              },
              false
            ),
            [
              _vm._l(_vm.selectedWidget.tabs, function (tpItem, tpIdx) {
                return _c(
                  "li",
                  { key: tpIdx, staticClass: "col-item" },
                  [
                    _c("span", { staticStyle: { "margin-right": "12px" } }, [
                      _vm._v("标签:" + _vm._s(tpIdx + 1)),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      staticStyle: { width: "155px" },
                      attrs: { type: "text" },
                      model: {
                        value: tpItem.options.label,
                        callback: function ($$v) {
                          _vm.$set(tpItem.options, "label", $$v)
                        },
                        expression: "tpItem.options.label",
                      },
                    }),
                    _vm._v(" "),
                    _c("i", { staticClass: "iconfont icon-drag drag-option" }),
                    _vm._v(" "),
                    _c("el-button", {
                      staticClass: "col-delete-button",
                      attrs: {
                        circle: "",
                        plain: "",
                        size: "mini",
                        type: "danger",
                        icon: "el-icon-minus",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.deleteTabPane(_vm.selectedWidget, tpIdx)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.addTabPane(_vm.selectedWidget)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.i18nt("designer.setting.addTabPane")))]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }